__turbopack_context__.v({
  "badge": "ParagraphDarkFeatures-module__GFn86W__badge",
  "badgeDot": "ParagraphDarkFeatures-module__GFn86W__badgeDot",
  "card": "ParagraphDarkFeatures-module__GFn86W__card",
  "desc": "ParagraphDarkFeatures-module__GFn86W__desc",
  "grid": "ParagraphDarkFeatures-module__GFn86W__grid",
  "header": "ParagraphDarkFeatures-module__GFn86W__header",
  "iconBox": "ParagraphDarkFeatures-module__GFn86W__iconBox",
  "inner": "ParagraphDarkFeatures-module__GFn86W__inner",
  "lead": "ParagraphDarkFeatures-module__GFn86W__lead",
  "name": "ParagraphDarkFeatures-module__GFn86W__name",
  "section": "ParagraphDarkFeatures-module__GFn86W__section",
  "title": "ParagraphDarkFeatures-module__GFn86W__title",
});
